"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardList = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sortBy_1 = tslib_1.__importDefault(require("lodash/sortBy"));
var DashboardListItem_1 = require("./DashboardListItem");
var DashboardListButton_1 = require("./DashboardListButton");
var dashboardPredicate_1 = require("../drill/utils/dashboardPredicate");
var alignPoints = [
    {
        align: "bl tl",
    },
    {
        align: "tl bl",
    },
];
var ITEM_HEIGHT = 25;
var DROPDOWN_BODY_WIDTH = 240;
var DROPDOWN_BODY_HEIGHT = 319;
exports.DashboardList = function (_a) {
    var selected = _a.selected, dashboards = _a.dashboards, onSelect = _a.onSelect;
    var selectedDashboard = react_1.useMemo(function () {
        return selected && dashboards.find(function (d) { return dashboardPredicate_1.dashboardMatch(d.identifier, d.ref, selected); });
    }, [selected, dashboards]);
    var intl = react_intl_1.useIntl();
    var dropdownLabel = selectedDashboard
        ? selectedDashboard.title
        : intl.formatMessage({
            id: "configurationPanel.drillConfig.selectDashboard",
        });
    var _b = tslib_1.__read(react_1.useState(""), 2), searchString = _b[0], setSearchString = _b[1];
    var items = react_1.useMemo(function () {
        var items = dashboards.filter(function (_a) {
            var title = _a.title;
            return title.toLowerCase().includes(searchString.toLowerCase());
        });
        if (selectedDashboard) {
            items = items.map(function (item) {
                return item.identifier === selectedDashboard.identifier ? tslib_1.__assign(tslib_1.__assign({}, item), { selected: true }) : item;
            });
        }
        return sortBy_1.default(items, function (dashboard) { return dashboard.title.toLowerCase(); });
    }, [dashboards, searchString, selectedDashboard]);
    var searchPlaceholder = intl.formatMessage({
        id: "configurationPanel.drillConfig.drillIntoDashboard.searchPlaceholder",
    });
    return (react_1.default.createElement(sdk_ui_kit_1.Dropdown, { className: "s-dashboards-dropdown", closeOnParentScroll: true, closeOnMouseDrag: false, closeOnOutsideClick: true, alignPoints: alignPoints, renderBody: function (_a) {
            var closeDropdown = _a.closeDropdown;
            return (react_1.default.createElement(sdk_ui_kit_1.DropdownList, { className: "dashboards-dropdown-body s-dashboards-dropdown-body", width: DROPDOWN_BODY_WIDTH, height: DROPDOWN_BODY_HEIGHT, searchString: searchString, searchPlaceholder: searchPlaceholder, itemHeight: ITEM_HEIGHT, showSearch: true, items: items, scrollToItem: selectedDashboard, onSearch: setSearchString, renderItem: function (_a) {
                    var item = _a.item;
                    var isSelected = selectedDashboard && item.selected;
                    return (react_1.default.createElement(DashboardListItem_1.DashboardListItem, { isSelected: isSelected, title: item.title, onClick: function () {
                            onSelect(item);
                            closeDropdown();
                        }, accessibilityLimitation: item.accessibilityLimitation }));
                } }));
        }, onOpenStateChanged: function () {
            setSearchString("");
        }, renderButton: function (_a) {
            var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
            return (react_1.default.createElement(DashboardListButton_1.DashboardListButton, { accessibilityLimitation: selectedDashboard === null || selectedDashboard === void 0 ? void 0 : selectedDashboard.accessibilityLimitation, label: dropdownLabel, isOpen: isOpen, toggleDropdown: toggleDropdown }));
        } }));
};
//# sourceMappingURL=DashboardList.js.map